import { z } from "zod";

import { createLocalStorageDef } from "~/lib/local-storage";

export const loginCredentialsSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  userId: z.string(),
});
export type LoginCredentialsType = z.infer<typeof loginCredentialsSchema>;

export const loginCredentials = createLocalStorageDef(
  "studio_login_credentials",
  loginCredentialsSchema
);
